"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LSRE1069Service = void 0;
var LaunchDarkly_service_1 = require("./LaunchDarkly.service");
var internal_compatibility_1 = require("rxjs/internal-compatibility");
var operators_1 = require("rxjs/operators");
var utils_1 = require("./eventCollector/core/utils");
var helper_1 = require("../helper");
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var Http_service_1 = require("../../core/services/http/Http.service");
var LSRE1069Service = /** @class */ (function () {
    function LSRE1069Service(httpService, launchDarklyService, seismicHelper) {
        this.httpService = httpService;
        this.launchDarklyService = launchDarklyService;
        this.seismicHelper = seismicHelper;
        this.httpService.addInterceptor(this);
    }
    /**
     * @see: LSRE-1069
     */
    LSRE1069Service.prototype.intercept = function (request, next) {
        var _this = this;
        var ROOT_URL = this.seismicHelper.getRootURL();
        var url = ROOT_URL + "/api/systemsetting/v1/featureToggleSettings";
        var ldFlagObservable = internal_compatibility_1.fromPromise(this.launchDarklyService.getValueAsBoolean('library-enable-https-retry-logic'));
        // Prevent infinite loop!
        if (request.options.url === url) {
            return next.handle(request);
        }
        return ldFlagObservable.pipe(operators_1.tap(function () { return __awaiter(_this, void 0, void 0, function () {
            var value, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.launchDarklyService.getValueAsBoolean('library-enable-https-retry-logic')];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, value];
                    case 2:
                        ex_1 = _a.sent();
                        console.info('was unable to retrieve launch darkly toggle library-enable-https-retry-logic. defaulting to false');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }), operators_1.mergeMap(function (value) {
            if (value && !utils_1.hasOwnProperty(request.options, 'retryCount')) {
                return next.handle(request.clone({
                    retryCount: 2,
                    retryFilterFunction: function (response) {
                        return request.options.method === 'GET' && [502].indexOf(response.statusCode) >= 0;
                    },
                }));
            }
            return next.handle(request);
        }), operators_1.shareReplay());
    };
    LSRE1069Service = __decorate([
        CommonService_decorator_1.CommonService('LSRE1069Service'),
        __metadata("design:paramtypes", [Http_service_1.HttpService,
            LaunchDarkly_service_1.LaunchDarklyService,
            helper_1.SeismicHelper])
    ], LSRE1069Service);
    return LSRE1069Service;
}());
exports.LSRE1069Service = LSRE1069Service;
//# sourceMappingURL=LSRE1069.service.js.map